// FIXME: these values should be returned by the backend
import type { WorkspaceType } from "./types.ts";

export const DEFAULT_IMAGE_SIZE = 1024;
export const UPLOAD_MAX_IMAGE_SIZE = 1024;
export const MAX_PIXEL_DIMENSION = 4096;
export const UPLOAD_MAX_IMAGES = 4;

export const WATERMARK_COST = 30;
export const TRAINING_COST = 20;
export const CREDIT_PRICE: Record<WorkspaceType, number> = {
  basic: 33,
  pro: 26.33,
  premium: 19.67,
  team: 19.67,
  // FIXME: We currently disable additional credits for enterprise accounts. Before enabling we should either define a
  //  static price (probably 19.67) or a manual price defined at the workspace level.
  enterprise: 0,
};
// FIXME: These values should be returned by the backend
export const SUBSCRIPTION_MONTHLY_PRICES: Partial<
  Record<WorkspaceType, number>
> = {
  pro: 19,
  premium: 39,
  team: 149,
};
export const SUBSCRIPTION_YEARLY_PRICES: Partial<
  Record<WorkspaceType, number>
> = {
  pro: 190,
  premium: 390,
  team: 1490,
};
export const BILLING_PERIODS = ["monthly", "yearly"] as const;

export const STYLE_MODEL_IMAGES_KIND = [
  "PHOTOGRAPHY",
  "ILLUSTRATION_2D",
  "GRAPHIC_3D",
  "ICON",
  "OTHER",
];

export const OBJECT_MODEL_TYPE = "OBJECT";
export const CHARACTER_MODEL_TYPE = "CHARACTER";
export const STYLE_MODEL_TYPE = "STYLE";

export const MODEL_TYPES = [
  STYLE_MODEL_TYPE,
  OBJECT_MODEL_TYPE,
  CHARACTER_MODEL_TYPE,
] as const;

// FIXME: These are duplicated UUIDs from the backend. Ideally, we should not replicate them here.
export const GENERIC_STYLE_MODEL_UUID = "0025e1b0-c447-4d92-b1ee-487a098fea54";
export const HYPER_RESOLUTION_STYLE_MODEL_UUID =
  "a918d550-675d-419d-b1fa-61462d1a5854";
export const PHOTO_REALISTIC_STYLE_MODEL_UUID =
  "79fa719a-bccb-4206-b37a-56b28f495d5d";

export type DefaultModelProperties = {
  description: string;
  thumbnail_url: string;
  image_training_urls: string[];
};

export const DEFAULT_STYLE_MODELS_PROPERTIES: Record<
  string,
  DefaultModelProperties | undefined
> = {
  [HYPER_RESOLUTION_STYLE_MODEL_UUID]: {
    description:
      "Hyper Resolution generates 2048x2048 pixels ultra-high-quality images with extreme detail, vibrant colors, " +
      "and razor-sharp clarity. From intricate macro photography to breathtaking landscapes and futuristic " +
      "cityscapes, it ensures every pixel is perfected.",
    thumbnail_url:
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_thumbnail.png",
    image_training_urls: [
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_1.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_2.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_3.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_4.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_5.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_6.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_7.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_8.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_9.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_10.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_11.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_12.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_13.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_14.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/hyper_resolution/hyper_resolution_15.png",
    ],
  },
  [PHOTO_REALISTIC_STYLE_MODEL_UUID]: {
    description:
      "Photo Realism creates incredibly realistic images that look like they were taken with a high-end smartphone, " +
      "not generated by AI. It captures natural lighting, authentic imperfections, and true-to-life textures, " +
      "making every photo feel genuine. Whether it’s a casual snapshot, a detailed close-up, or a spontaneous " +
      "street scene, the results are lifelike, sharp, and full of depth.",
    thumbnail_url:
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_thumbnail.jpeg",
    image_training_urls: [
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_1.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_2.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_3.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_4.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_5.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_6.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_7.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_8.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_9.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_10.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_11.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_12.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_13.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_14.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_15.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_16.png",
      "https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/photo_realistic/photo_realistic_17.png",
    ],
  },
};

export const DEFAULT_MODELS_UUIDS = Object.keys(
  DEFAULT_STYLE_MODELS_PROPERTIES,
);
